import React from "react";
import { motion } from "framer-motion";
import {
  FaProjectDiagram,
  FaUsers,
  FaTasks,
  FaBell,
  FaRupeeSign,
} from "react-icons/fa";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";

export default function Dashboard() {
  const projectStatusData = [
    { name: "Ongoing", value: 12 },
    { name: "Completed", value: 18 },
    { name: "Pending", value: 6 },
    { name: "On Hold", value: 4 },
  ];

  const COLORS = ["#2563eb", "#16a34a", "#facc15", "#f87171"];

  const recentDeadlines = [
    { title: "CRM Revamp", due: "2025-05-20" },
    { title: "API Gateway Upgrade", due: "2025-05-23" },
    { title: "UI Overhaul", due: "2025-05-25" },
  ];

  const teamMembers = [
    {
      name: "Jitendra Kumar",
      role: "Developer",
      avatar: "https://cdn-icons-png.flaticon.com/128/149/149071.png",
    },
    {
      name: "Ashish Poddar",
      role: "Developer",
      avatar: "https://cdn-icons-png.flaticon.com/128/149/149071.png",
    },
    {
      name: "Ashutosh Oraon",
      role: "Developer",
      avatar: "https://cdn-icons-png.flaticon.com/128/149/149071.png",
    },
    {
      name: "Aditya Anand",
      role: "Developer",
      avatar: "https://cdn-icons-png.flaticon.com/128/149/149071.png",
    },
  ];

  const notifications = [
    "🔔 New task assigned to you",
    "📢 Project Alpha marked as Completed",
    "👥 New member joined your team",
    "✅ API Health check passed successfully",
  ];

  return (
    <div className="p-6 bg-gray-50 min-h-screen space-y-8">
      {/* Header */}
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold text-gray-800">
          📊 Project Dashboard
        </h1>
        <button className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700">
          + New Project
        </button>
      </div>

      {/* Analytics Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {[
          {
            icon: FaProjectDiagram,
            value: 42,
            label: "Total Projects",
            color: "text-blue-600",
          },
          {
            icon: FaTasks,
            value: 134,
            label: "Completed Projects",
            color: "text-green-600",
          },
          {
            icon: FaUsers,
            value: 22,
            label: "Ongoing Projects",
            color: "text-purple-600",
          },
          {
            icon: FaRupeeSign,
            value: "10",
            label: "On-hold Projects",
            color: "text-yellow-500",
          },
          {
            icon: FaRupeeSign,
            value: "10",
            label: "Upcoming Projects",
            color: "text-yellow-500",
          },
          {
            icon: FaRupeeSign,
            value: "10",
            label: "Delayed Projects",
            color: "text-yellow-500",
          },
        ].map((item, i) => (
          <motion.div
            key={i}
            whileHover={{ scale: 1.03 }}
            className="p-6 bg-white rounded-2xl shadow border flex items-center gap-4"
          >
            <item.icon className={`text-4xl ${item.color}`} />
            <div>
              <h3 className="text-2xl font-bold">{item.value}</h3>
              <p className="text-gray-500">{item.label}</p>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Charts & Deadlines */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        {/* Project Status Pie Chart */}
        <div className="bg-white p-6 rounded-2xl shadow border">
          <h3 className="text-lg font-semibold mb-4">
            Project Status Overview
          </h3>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie
                data={projectStatusData}
                dataKey="value"
                nameKey="name"
                outerRadius={100}
              >
                {projectStatusData.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Recent Deadlines */}
        <div className="bg-white p-6 rounded-2xl shadow border space-y-3">
          <h3 className="text-lg font-semibold mb-4">📅 Upcoming Deadlines</h3>
          {recentDeadlines.map((item, i) => (
            <div
              key={i}
              className="flex justify-between items-center border-b py-2"
            >
              <span className="text-gray-700">{item.title}</span>
              <span className="text-sm text-gray-500">{item.due}</span>
            </div>
          ))}
        </div>

        {/* Notifications */}
        <div className="bg-white p-6 rounded-2xl shadow border space-y-3">
          <h3 className="text-lg font-semibold mb-4">🔔 Notifications</h3>
          {notifications.map((note, i) => (
            <div key={i} className="text-gray-700 border-b py-2">
              {note}
            </div>
          ))}
        </div>
      </div>

      {/* Team Overview */}
      <div className="bg-white p-6 rounded-2xl shadow border">
        <h3 className="text-lg font-semibold mb-4">👥 Team Members</h3>
        <div className="flex gap-6">
          {teamMembers.map((member, i) => (
            <div key={i} className="flex items-center gap-3">
              <img
                src={member.avatar}
                alt={member.name}
                className="h-14 w-14 rounded-full"
              />
              <div>
                <h4 className="font-semibold text-gray-800">{member.name}</h4>
                <p className="text-sm text-gray-500">{member.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
